// not sure why eslint thinks that jQuery isn't being used??
// silence the error
/* eslint-disable no-unused-vars */
const jQuery = require('jquery');

/* global jQuery */
/*!
* FitText.js 1.2
*
* Copyright 2011, Dave Rupert http://daverupert.com
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*
* Date: Thu May 05 14:23:00 2011 -0600
*/

(function ($) {
    $.fn.fitText = function (kompressor, options) {
        // Setup options
        const compressor = kompressor || 1;
        const settings = $.extend({
            minFontSize: Number.NEGATIVE_INFINITY,
            maxFontSize: Number.POSITIVE_INFINITY,
        }, options);

        return this.each(function () {
        // Store the object
            const $this = $(this);

            // Resizer() resizes items based on the object width divided by the compressor * 10
            const resizer = function () {
                $this.css('font-size', Math.max(Math.min($this.width() / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
            };

            // Call once to set.
            resizer();

            // Call on resize. Opera debounces their resize by default.
            $(window).on('resize.fittext orientationchange.fittext', resizer);
        });
    };
}(jQuery));

jQuery('.js-fittext').each(function () {
    jQuery(this).fitText(parseFloat(jQuery(this).data('kompressor') || 3), { minFontSize: jQuery(this).data('minFontSize') || '16px', maxFontSize: jQuery(this).data('maxFontSize') || '32px' });
});

/* eslint-enable no-unused-vars */
